import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const LoanListNavUI = ({context, page}) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Loans' to='/su/loans' active={page==='loans'} />
      <TabLinkUI label='EMI Tracker' to='/su/repayments' active={page==='repayments'} />
      <TabLinkUI label='Fee Tracker' to='/su/fees' active={page==='fees'} />
      <TabLinkUI label='Security Report' to='/su/security' active={page==='dsra'} />
      <TabLinkUI label='Penalty Tracker' to='/su/penalty' active={page==='penalty'} />
      <TabLinkUI label='Compliance' to='/su/csStatus' active={page==='csStatus'} />
      <TabLinkUI label='Disbursements' to='/su/disbursements' active={page==='disbursements'} />
      <TabLinkUI label='Distribution' to='/su/distribution' active={page==='distribution'} />
    </div>
    <div className='g_m_top_50' />
  </div>

export default LoanListNavUI
